<div class="m-4">
  <form [formGroup]="summaryDisplayForm" class="pb-5">
    <div class="p-fluid p-formgrid mt-4" *ngIf="this.planName == 'Petitioner Plan'; else firmInfo">
      <div class="row" class="font-weight-bold mb-4 lead">
        Company Details
        <button type="button" [disabled]="disableFields" (click)="editSection(0)"
          class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
          Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
        </button>
      </div>
      <div class="row">
        <div class="col-3 pl-0">
          <label class="mb-0 font-weight-bold">Company/Organization</label>
          <p> {{ summaryDisplayForm.value.companyName ? summaryDisplayForm.value.companyName : '-'}}</p>
        </div>
        <div class="col-6">
          <label class="mb-0 font-weight-bold">Business Type</label>
          <p>
            <span *ngFor="let data of summaryDisplayForm.value.businessType; let i = index">
              {{data.name}} {{i === summaryDisplayForm.value.businessType.length -1 ? '' : ',&nbsp; ' }}
            </span>
            <span *ngIf="summaryDisplayForm.value.othername;">
              {{", Other : " + summaryDisplayForm.value.othername}} 
            </span>
          </p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3 pl-0">
          <label class="mb-0 font-weight-bold">Incorporation Location</label>
          <p> {{ summaryDisplayForm.value.incorporationLocation ? summaryDisplayForm.value.incorporationLocation : '-'}}
          </p>
        </div>
        <div class="col-3">
          <label class="mb-0 font-weight-bold">Establishment Date</label>
          <p> {{ summaryDisplayForm.value.establishmentDate ? summaryDisplayForm.value.establishmentDate : '-' }}</p>
        </div>
        <div class="col-3">
          <label class="mb-0 font-weight-bold">No. of Employees in U.S.</label>
          <p> {{ summaryDisplayForm.value.noOfEmployees ? summaryDisplayForm.value.noOfEmployees : '-'}}</p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3 pl-0">
          <label class="mb-0 font-weight-bold">NAICS Code</label>
          <p> {{ summaryDisplayForm.value.naicsCode ? summaryDisplayForm.value.naicsCode : '-' }}</p>
        </div>
        <div class="col-3">
          <label class="mb-0 font-weight-bold">FEI Number</label>
          <p> {{ summaryDisplayForm.value.feiNumber ? summaryDisplayForm.value.feiNumber : '-'}}</p>
        </div>
      </div>
    </div>

    <ng-template #firmInfo>
      <div class="p-fluid p-formgrid mt-4">
        <div class="row" class="font-weight-bold mb-4 lead">
          Firm Details
          <button type="button" [disabled]="disableFields" (click)="editSection(0)"
            class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
            Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
          </button>
        </div>
        <div class="row">
          <div class="col-3 pl-0">
            <label class="mb-0 font-weight-bold">Firm Name</label>
            <p> {{ summaryDisplayForm.value.firmName ? summaryDisplayForm.value.firmName : '-'}}</p>
          </div>
          <div class="col-3">
            <label class="mb-0 font-weight-bold">FEI Number</label>
            <p> {{ summaryDisplayForm.value.feiNumberFirm ? summaryDisplayForm.value.feiNumberFirm : '-'}}</p>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="p-fluid p-formgrid mt-4">
      <div class="row" class="font-weight-bold mb-4 lead">
        List of Users
        <button type="button" (click)="editSection(1)" [disabled]="disableFields"
          class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
          Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
        </button>
      </div>
      <table *ngIf="summaryDisplayForm.value.listOfUser;else NoData">
        <tr>
          <th colspan="4">Users</th>
          <th colspan="4">Roles</th>
          <th colspan="4">Email</th>
        </tr>
        <tr *ngFor="let data of summaryDisplayForm.value.listOfUser;">
          <td colspan="4">{{data.firstName +' '+ data.lastName }}</td>
          <td *ngIf="this.planName == 'Petitioner Plan'; else attflow" colspan="4">Petitioner Admin</td>
          <ng-template #attflow>
            <td colspan="4">Lawfirm Admin</td>
          </ng-template>
          <td colspan="4">{{data.email}}</td>
        </tr>
      </table>
      <ng-template #NoData>
        <table>
          <tr>
          <th colspan="4">Users</th>
          <th colspan="4">Roles</th>
          <th colspan="4">Email</th>
          </tr>
          <tr>
            <td colspan="4">No Data</td>
          </tr>
        </table>
      </ng-template>
    </div>

    <div class="p-fluid p-formgrid mt-4" *ngIf="this.planName !== 'Petitioner Plan'">
      <div class="row" class="font-weight-bold mb-4 lead">
        Added Companies
        <button type="button" (click)="editSection(2)" [disabled]="disableFields"
          class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
          Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
        </button>
      </div>
      <table *ngIf="summaryDisplayForm.value;else NoData">
        <tr>
          <th colspan="4">Company</th>
          <th colspan="4">Contact</th>
          <th colspan="4">Email</th>
          <th colspan="4">Address</th>
          <th colspan="4">User(Role)</th>
        </tr>
        <tr>
          <td colspan="4">{{summaryDisplayForm.value.companyNameClient}}</td>
          <td colspan="4">{{summaryDisplayForm.value.companyNameClientMobile}}</td>
          <td colspan="4">{{summaryDisplayForm.value.companyNameClientEmail}}</td>
          <td colspan="4">{{summaryDisplayForm.value.companyNameClientAddress}}</td>
          <td colspan="4">{{summaryDisplayForm.value.companyNameClientUserName}}</td>
        </tr>
      </table>
      <ng-template #NoData>No Data</ng-template>
    </div>

      <div class="p-fluid p-formgrid mt-4" *ngIf="this.planName == 'Petitioner Plan'; else attorney">
      <div class="row" class="font-weight-bold mb-4 lead">
        Beneficiaries to be Invited
        <button type="button" (click)="editSectionBeneInvite(2)" [disabled]="disableFields"
          class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
          Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
        </button>
      </div>
      <table *ngIf="summaryDisplayForm.value.listOfInvitedBeneficiaries;else noBeneficiaries">
        <tr>
          <th colspan="4">Name</th>
          <th colspan="4">User ID</th>
          <th colspan="4">Email</th>
        </tr>
        <tr *ngFor="let data of summaryDisplayForm.value.listOfInvitedBeneficiaries;">
          <td colspan="4">{{data.firstName}}</td>
          <td colspan="4">{{data.userId}}</td>
          <td colspan="4">{{data.emailId}}</td>
        </tr>
      </table>
      <ng-template #noBeneficiaries>
        <table>
        <tr>
          <th colspan="4">Name</th>
          <th colspan="4">User ID</th>
          <th colspan="4">Email</th>
        </tr>
        <tr>
          <td colspan="4">No Data</td>
        </tr>
      </table>
      </ng-template>
    </div> 

     <ng-template #attorney>
    <div class="p-fluid p-formgrid mt-4">
      <div class="row" class="font-weight-bold mb-4 lead">
        Beneficiaries to be Invited
        <button type="button" (click)="editSectionBeneInvite(2)" [disabled]="disableFields"
          class="p-button-text p-button-rounded  float-right im-btn im-btn-with-icon im-btn-outline-primary button_whitebg ">
          Edit <span class="ml-2"><i class="fa fa-pencil"></i></span>
        </button>
      </div>
      <table *ngIf="summaryDisplayForm.value.listOfInvitedBeneficiaries;else noBeneficiaries">
        <tr>
          <th colspan="4">Immigration Type</th>
          <th colspan="4">Name</th>
          <th colspan="4">User ID</th>
          <th colspan="4">Email</th>
        </tr>
        <tr *ngFor="let data of summaryDisplayForm.value.listOfInvitedBeneficiaries;">
          <td colspan="4">{{data.immigrationType}}</td>
          <td colspan="4">{{data.firstName}}</td>
          <td colspan="4">{{data.userId ? data.userId:'N.A'}}</td>
          <td colspan="4">{{data.emailId}}</td>
        </tr>
      </table>
      <ng-template #noBeneficiaries>
        <table>
        <tr>
          <th colspan="4">Immigration Type</th>
          <th colspan="4">Name</th>
          <th colspan="4">User ID</th>
          <th colspan="4">Email</th>
        </tr>
        <tr>
          <td colspan="4">No Data</td>
        </tr>
      </table>
      </ng-template>
    </div>
  </ng-template>

    <div class="panel panel-default panel-info mt-5">
      <div class="panel-body">
        <p class="panel-text"><b>Let us know when you want to start the free trial plan ?</b></p>
        <div class="row">
        <div class="col-md-3 ml-n3">
          <label class="d-block panel-text required">Free trial start date</label>
          <p-calendar [disabled]="disableFields" (onSelect)="getPlanDate($event)" showButtonBar="true" placeholder="Select Date"
          [minDate]="maxDate" [monthNavigator]="true" [yearNavigator]="true" formControlName="date"
          name="date" class="w-100" yearRange="1910:2050"
          dateFormat="mm-dd-yy" [showIcon]="true" required=""></p-calendar>
        </div>
        <div class="col-md-6" style="margin-top: 35px" *ngIf="this.planDisabled">
          <p class="dateText">You will be able to use this free trial for 15 days till 
            <b>{{ this.getPlanStartDate |  date  }} </b></p>
        </div>
        </div>
      </div>
    </div>

    <div class="p-field-checkbox">
      <p-checkbox (onChange)="checkboxClick($event)" binary="true" inputId="binary"></p-checkbox>
      <label for="binary" style="color: #0b87ea">I ACCEPT THE TERMS OF USE</label>
   </div>
   <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />

    <div class="row mt-2">
      <div class="col-6"></div>
      <div class="col text-right">
        <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
          Cancel
        </button>
        <div class="border-right d-inline-block mr-4" style="height:46px"></div>
        <button (click)="onPrevious()" class="im-btn im-btn-primary im-btn-md">
          Previous
        </button>
        <button (click)="onSubmit()"  [disabled]="agree" type="button" class="im-btn im-btn-primary im-btn-md mx-2">
          Finish
        </button>
      </div>
    </div>
  </form>
</div>